module.exports = __webpack_public_path__ + "img/sab-logo.74691f61.png";